<template>
    <b-col>
    <recognition-evaluation-form></recognition-evaluation-form>
    </b-col>
</template>

<script>
 import RecognitionEvaluationForm from '@/components/applicant/recognation/RecognitionEvaluationForm'
    export default {
        name: "Index",
        components:{
          RecognitionEvaluationForm
        },
        computed:{

        },
       methods:{
         fetchRecognition(){
            this.$store.dispatch('applicant/actionSetRecognition', this.$route.params.id)
          }
        },
      async mounted() {
          await this.fetchRecognition
      }
    }
</script>

<style scoped>

</style>
